import { render } from "./IFrameModal.vue?vue&type=template&id=19752777"
import script from "./IFrameModal.vue?vue&type=script&lang=js"
export * from "./IFrameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__